import { useRef, Suspense } from "react";
import { Canvas, useFrame, useLoader } from "@react-three/fiber";
import { Float, Sparkles } from "@react-three/drei";
import * as THREE from "three";

function LogoMesh() {
  const texture = useLoader(THREE.TextureLoader, "/assets/logo-alpha.png");
  texture.colorSpace = THREE.SRGBColorSpace;
  const mesh = useRef();

  useFrame((state) => {
    if (!mesh.current) return;
    const { x, y } = state.pointer;
    const t = state.clock.elapsedTime;
    mesh.current.rotation.y = THREE.MathUtils.lerp(mesh.current.rotation.y, x * 0.42 + Math.sin(t * 0.4) * 0.12, 0.06);
    mesh.current.rotation.x = THREE.MathUtils.lerp(mesh.current.rotation.x, -y * 0.3 + Math.cos(t * 0.5) * 0.06, 0.06);
  });

  return (
    <Float speed={1.4} rotationIntensity={0.25} floatIntensity={0.8}>
      <mesh ref={mesh}>
        <planeGeometry args={[4.4, 3.3, 96, 96]} />
        <meshStandardMaterial
          map={texture}
          transparent
          alphaTest={0.06}
          bumpMap={texture}
          bumpScale={1.4}
          roughness={0.38}
          metalness={0.55}
          emissive={"#f5f2ec"}
          emissiveMap={texture}
          emissiveIntensity={0.22}
        />
      </mesh>
    </Float>
  );
}

export default function LogoScene() {
  return (
    <Canvas
      data-testid="logo-3d-canvas"
      dpr={[1, 1.75]}
      camera={{ position: [0, 0, 6.2], fov: 42 }}
      gl={{ antialias: true, alpha: true }}
      style={{ background: "transparent" }}
    >
      <ambientLight intensity={0.25} />
      <spotLight position={[0, 4, 6]} angle={0.5} penumbra={0.8} intensity={140} color="#ffffff" />
      <pointLight position={[-5, 1.5, 3]} intensity={55} color="#ff1053" />
      <pointLight position={[5, -1, 3]} intensity={45} color="#00f0ff" />
      <Suspense fallback={null}>
        <LogoMesh />
        <Sparkles count={90} scale={[10, 7, 4]} size={2.2} speed={0.25} opacity={0.5} color="#ffffff" />
      </Suspense>
    </Canvas>
  );
}
